import firehoseAdapter from './firehoseAdapter';
import { getDeviceId, isTouchFriendly, getURLParams, extractUTMKeys, getReferrer } from 'utils';
import get from 'lodash/get';
import { store } from '../../App';

/*Currently logged in user*/
let currentUserId = 'GUEST';
let caseId = '';

const AppAnalytics = {};

AppAnalytics.reportEvent = function(event) {
  try {
    //Global columns available across app

    const params = getURLParams();
    const utmKeys = extractUTMKeys();
    const { utmSource = '', utmMedium = '', utmCampaign = '' } = utmKeys;

    /**
     * Get state from redux and add default context to every event
     */
    const stateObj = store.getState();
    currentUserId = get(stateObj, 'user.userId', 'GUEST');

    const paramsAndConfig = get(stateObj, 'report.context', {});

    const assessmentName = get(stateObj, 'assessment.assessmentName', '');

    caseId = get(stateObj, 'report.caseId', '');

    const referrer = get(params, 'referrer', '');

    event.context = {
      assessmentName: assessmentName,
      ...get(event, 'context', {}),
      ...paramsAndConfig,
    };
    event.context.score = stateObj.report?.context?.rs;
    event.context.bucket = stateObj.report?.riskLevel;
    event.user_id = currentUserId || get(stateObj, 'report.userId', 'GUEST');
    event.device_id = getDeviceId();
    event.isMobile = isTouchFriendly;
    event.channel = get(params, 'channel', '');
    event.shareChannel = get(params, 'sc', '');
    event.utm_source = utmSource;
    event.utm_medium = utmMedium;
    event.utm_campaign = utmCampaign;
    event.url = window.location.href;
    event.host = window.location.host;
    event.referrer = referrer?.length ? referrer : getReferrer();
    event.caseId = caseId;
    firehoseAdapter.reportEvent(event);
  } catch (err) {
    console.error('Error in App Analytics', err);
  }
  return;
};

AppAnalytics.reportMessage = function() {};

AppAnalytics.setEnabled = function() {};

AppAnalytics.flush = function() {
  return firehoseAdapter.flush();
};

AppAnalytics.reportNonFatal = function(error) {
  try {
    if (!(error instanceof Error)) {
      error = new Error(error);
    }
  } catch (e) {
    console.error('reportNonFatal err', e);
  }
};

AppAnalytics.reportCrash = function() {};

AppAnalytics.setUser = function(id) {
  currentUserId = id;
};

AppAnalytics.setCaseId = function(id) {
  caseId = id;
};

export default AppAnalytics;
